import {LocalStyleSheet} from "../../../utils/types";

export const styles: LocalStyleSheet = {
    devWrap: {
        position: 'absolute',
        top: '15%',
        right: 0,
    },
    devLang: {
        display: 'flex',
        flexDirection: 'column'
    },
    navRight: {
        float: 'right'
    }
}
